require('./bootstrap');

import 'babel-polyfill';

require('./snippets/flash_message');
require('pc-bootstrap4-datetimepicker');

window.Vue = require('vue');

//import lodash as an instance method for all components as '$_'
Object.defineProperty(Vue.prototype, '$_', {value: _});

// for open ckeditor img in modal
window.magnificPopup = require('magnific-popup');



// WEBPACK FOOTER //
// ./resources/js/app.js